import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

export default function BackButton({
  label, 
  onClick, 
  disabled
}) {

  return (
    <Button
      variant="text"
      onClick={onClick}
      disabled={disabled}
      sx={{ 
        textTransform: "none",
        padding: "0px"
      }}
    >
      <ArrowBackIosIcon sx={{fontSize: "14px", color: disabled ? "black_solid.20":"black_solid.60"}} />
      <Typography variant="subhead2" color="primary.60">{label}</Typography>
    </Button>  
  );
}

BackButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};